(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7658],{

/***/ 17658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutWidget035": function() { return /* binding */ LayoutWidget035; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var features_translations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91929);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52853);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65202);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87367);
/* harmony import */ var _LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54740);
/* harmony import */ var _LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9__);










var LayoutWidget035 = function(param) {
    var payload = param.payload;
    var ref, ref1, ref2, ref3;
    var t = (0,features_translations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().t;
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_4__/* .buildWidgetInstanceId */ .G1)("l035", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_5__/* .WIDGETS_REGISTRY["LAYOUT-WIDGET"] */ .R["LAYOUT-WIDGET"]);
    var courses = (0,shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_7__/* .useCollectedData */ .M)(instanceId, [
        {
            name: "courses",
            defaultValue: []
        }, 
    ]).courses;
    var ref4 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useToggle */ .OT)(), opened = ref4.opened, onOpen = ref4.onOpen, onClose = ref4.onClose;
    var ref5;
    var course = (ref5 = courses === null || courses === void 0 ? void 0 : courses[0]) !== null && ref5 !== void 0 ? ref5 : {};
    var ref6;
    var requestType = (ref6 = course === null || course === void 0 ? void 0 : (ref = course.button) === null || ref === void 0 ? void 0 : ref.type) !== null && ref6 !== void 0 ? ref6 : "form";
    var ref7;
    var form = (ref7 = (ref1 = course.button) === null || ref1 === void 0 ? void 0 : ref1.form) !== null && ref7 !== void 0 ? ref7 : {};
    var ref8;
    var buttonText = (ref8 = (ref2 = course.button) === null || ref2 === void 0 ? void 0 : ref2.buttonText) !== null && ref8 !== void 0 ? ref8 : "";
    var ref9;
    var link = (ref9 = (ref3 = course.button) === null || ref3 === void 0 ? void 0 : ref3.link) !== null && ref9 !== void 0 ? ref9 : "";
    if (courses.length === 0) {
        return null;
    }
    var items = [
        {
            id: "date",
            label: t("date"),
            text: course.courseStartDate
        },
        {
            id: "time",
            label: t("time"),
            text: course.courseDuration
        },
        {
            id: "price",
            label: t("price"),
            text: course.coursePrice
        },
        {
            id: "place",
            label: t("place"),
            text: course.courseFormat
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().top),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().block),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading4 */ .k8, {
                                    className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().headline),
                                    color: "dark",
                                    children: course.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                    value: course.description,
                                    className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().description)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().block),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .DetailsBlock */ .IR, {
                                    items: items,
                                    className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().course)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["button-wrap"]),
                                    children: requestType === "form" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Action */ .aU, {
                                        onClick: onOpen,
                                        className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().play),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                                className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().label),
                                                appearance: "bold",
                                                color: "light",
                                                uppercase: true,
                                                children: buttonText
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrow),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                                    className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
                                                    name: "arrow_right"
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .PageLink */ .H_, {
                                        className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().play),
                                        link: link,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                                className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().label),
                                                appearance: "bold",
                                                color: "light",
                                                uppercase: true,
                                                children: buttonText
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrow),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                                    className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
                                                    name: "arrow_right"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ModalWrapper */ .AB, {
                                    onCloseModal: onClose,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                        item: form,
                                        metaData: {
                                            type: "course",
                                            id: course.id
                                        },
                                        instanceId: instanceId,
                                        info: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .FormInfo */ .Nf, {
                                            title: course.title,
                                            date: course.timeDescription
                                        }),
                                        onReset: onClose
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageLite */ .NH, {
                    image: course.image,
                    className: (_LayoutWidget035_module_scss__WEBPACK_IMPORTED_MODULE_9___default().image)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LayoutWidget035);


/***/ }),

/***/ 54740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget035_wrapper__nathp","top":"LayoutWidget035_top__bYHE3","block":"LayoutWidget035_block__tmffk","headline":"LayoutWidget035_headline__sG4Oc","course":"LayoutWidget035_course__9PfFn","description":"LayoutWidget035_description__Mk_x6","button-wrap":"LayoutWidget035_button-wrap__trSZ4","play":"LayoutWidget035_play__wfkhG","arrow":"LayoutWidget035_arrow__HvdxT","icon":"LayoutWidget035_icon__hW22S","image":"LayoutWidget035_image__hzg4O"};

/***/ })

}]);